<template>
    <div class="container-shader">
        <h2><span style="color:lightcoral;font-weight: bold">F</span>requently <span style="color:lightcoral;font-weight: bold">A</span>sked <span style="color:lightcoral;font-weight: bold">Q</span>uestions
            <button @click.prevent="goBack">Back</button>
        </h2>
        <span>
            Business interface
        </span>
        <button class="question">What is the SaPPo - cloud service purpose?</button>
        <div class="panel">
            <br>This is a service that manage your schedule appointments,<br>You can check all requested appointments & create offices for your business.<br>
            <br>
        </div>
        <hr>
        <button class="question">I need an account to use SaPPo service?</button>
        <div class="panel">
            <br>Yes, You need an account to manage offices, appointments and the account valability <br> You need to pay a small fee / month to use this service.<br><br>
        </div>
        <hr>
        <button class="question">How it works?</button>
        <div class="panel">
            <br>The process it's very simple : <span>Request Access</span>- that action has 2 steps:
            1st step collects <span>Business Data </span> like name,location,email,
            <br>the 2nd step is the <span >Payment </span> process - pay the service fee (select number of month).
            The <span>SaPPo</span> will generate a private <span>Access Key</span> that should be use on <span>sign-in</span>
            The private <span>Access Key</span> could be saved locally (browser) to be used at the next <span>sign-in</span>
        </div>
        <hr>
        <button class="question">What about privacy?</button>
        <div class="panel">
            <br> A private <span>Access Key</span> will be created by SaPPo when the Payment process will be finished.<br>
            Each business will be uniquely identified by this  private <span>Access Key</span>.
            The email data will not be stored on the service data base.
            <br>
        </div>
        <hr>
        <button class="question">How can I use Appointments feature?</button>
        <div class="panel">
            <br>The <span>Appointments</span> card shows all customers requested appointments for Your business.
            You can filter appointments by <span>office name</span> and You can confirm a requested appointment <br><br>
        </div>
        <hr>
        <button class="question">How can I use the QR code ?</button>
        <div class="panel">
            <br>The QR code image should be integrated on your web site.
            <br> You have also the <span>Share</span> option that will share the service weblink<br><br>
        </div>
        <hr>
    </div>
</template>
<script>
    export default {
        name: 'BFaQ',
        data() {
            return {

            }
        },
        mounted() {
            this.addQuestionEvents()
        },
        methods: {
            goBack() {
              if(this.$store.getters.getLoginState) {
                  this.$router.push('/features')
              }else {
                  this.$router.push("/business_signin")
              }
            },
            addQuestionEvents () {
                let acc = document.getElementsByClassName("question");
                for (let i = 0; i < acc.length; i++) {
                    acc[i].addEventListener("click", function() {
                        this.classList.toggle("active");      // ????
                        let panel = this.nextElementSibling; // expand or resume panel
                        if (panel.style.maxHeight) {
                            panel.style.maxHeight = null
                        } else {
                            panel.style.maxHeight = panel.scrollHeight + "px"
                        }
                    });
                }
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }

    .container-shader{
        background-color: black;
        background-size: cover;
        margin: 0 auto;
        height: 100vh;
        width: 100%;
    }
    .question {
        background-color: #ffffff;
        color: #444;
        cursor: pointer;
        padding: 5px;
        width: 100%;
        border: none;
        text-align: left;
        outline: none;
        font-size: 20px;
        font-family: "Iowan Old Style";
        transition: 0.4s;
    }

    .question:hover {
        //background-color: #ffdddd;
        color: #dc143c;
        //font-weight: bold;
        //font-style: italic;
        //font-family: "American Typewriter";
        font-size: 22px;
    }

    .active{
        color:  #00008b;
    }
    .question:after {
        content: '\002B';
        color: black;
        font-weight: bold;
        float: right;
        margin-left: 5px;
    }

    .active:after {
        content: "\2212";
    }

    .panel {
        width: 100%;
        padding: 0px;
        background-color: black;
        max-height: 0px;
        overflow: hidden;
        font-size: 15px;
        float: left;
        text-align: left;
        font-family: "Avenir Next";
        transition: max-height 0.2s ease-out;
    }
    span {
        font-size: 20px;
        color: #ff8c00;
    }

    @media screen and (max-width: 600px) {
        button.question {
            font-size: 12px;
        }
        div.panel {
            font-size: 10px;
        }
    }
</style>